export default __webpack_public_path__ + "static/01-6eaa6e62d4be5f52831d63c839f011ee.png";